import { render, staticRenderFns } from "./errot.vue?vue&type=template&id=64cea588&scoped=true&"
import script from "./errot.vue?vue&type=script&lang=js&"
export * from "./errot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cea588",
  null
  
)

export default component.exports